import React, { useEffect, useRef, useState } from "react";
import ShipmentCard from "../ShipmentCard";
import { CustomParagraph, CustomTitle } from "../../../components";


const AnimatedShipmentCard = ({
  card,
  toggleDrawer,
  drawerState,
  openShipmentId,
  onExpire,
}) => {
  const [timeLeft, setTimeLeft] = useState(15);
  const [isVisible, setIsVisible] = useState(true);
  const intervalRef = useRef(null);
  const isDrawerOpenForThisCard = openShipmentId === card.id;

  const progressPercentage = (timeLeft / 15) * 100;

  // Countdown
  useEffect(() => {
    if (isDrawerOpenForThisCard || timeLeft <= 0) {
      clearInterval(intervalRef.current);
      return;
    }

    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [isDrawerOpenForThisCard]);

  // Remove card after fade out
  useEffect(() => {
    if (timeLeft <= 0) {
      setIsVisible(false);
      setTimeout(() => onExpire(card.id), 500);
    }
  }, [timeLeft, onExpire, card.id]);

  return (
    <div
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0px)" : "translateY(400px)",
        transition: "all 0.8s ease-in-out",
        zIndex:'999'
      }}
    >
      <ShipmentCard
        card={card}
        toggleDrawer={toggleDrawer}
        drawerState={drawerState}
        openShipmentId={openShipmentId}
      />

      {timeLeft > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "16px",
            marginBottom:'16px',
          }}
        >
          <CustomTitle
           text={isDrawerOpenForThisCard ? "Paused" : `Reordering in ${timeLeft}s`}
            fontSize="10px"
            fontWeight="400"
            lineHeight="16px"
            marginBottom={0}
            color={'#5e5e5e'}
            whiteSpace={"nowrap"}
          />
          <div style={{ width: "100%", }}>
            <div
              style={{
                height: "4px",
                backgroundColor: "#e2e2e2",
                borderRadius: "8px",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${progressPercentage}%`,
                  backgroundColor: "#afafaf",
                  transition: "width 1s linear",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnimatedShipmentCard;
